import React, { useState, useEffect } from "react";
import styles from "./Customers.module.sass";
import Overview from "./Overview";
import StatProspect from "./StatProspect";
import EvolutionProspect from "./EvolutionProspect";


import { getSessionDashboardData } from "../../services/sessionDashboard.service";

const SessionsFormationDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getSessionDashboardData();
        setDashboardData(data);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch session dashboard data:", err);
        setError("Impossible de charger les données du dashboard.");
        setDashboardData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className={styles.loading}>
        <p>Chargement du dashboard prospects...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.error}>
        <p style={{ color: 'red' }}>{error}</p>
      </div>
    );
  }

  return (
    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <Overview 
          className={styles.card} 
          overviewData={dashboardData?.overview}
        />

        <div className={styles.row}>
          <div className={styles.col}>
            <EvolutionProspect
              className={styles.card}
              evolutionData={dashboardData?.evolution}
            />
          </div>
          <div className={styles.col}>
            <StatProspect className={styles.card} />
          </div>
        </div>

      </div>
    </>
  );
};

export default SessionsFormationDashboard;
